import { createContext, useCallback, useMemo, useState } from 'react';
import { SearchCentroCostoRequest } from '../models/SearchCentroCostoRequest';
import { useSearchParams } from 'react-router-dom';

interface ICostCentreListContext {
  searchParams: SearchCentroCostoRequest | null;
  searchCostCentres: (request: SearchCentroCostoRequest) => void;
  reloadToken: number;
  reloadCostCentresAndFilters: () => void;
}

export const CostCentresListContext = createContext<ICostCentreListContext>({
  searchParams: {},
  searchCostCentres: () => {},
  reloadToken: 0,
  reloadCostCentresAndFilters: () => {},
});

export const CostCentresListProvider = ({ children }) => {
  const [searchParamsUrl, setSearchParamsUrl] = useSearchParams();
  const [reloadToken, setReloadToken] = useState(0);

  const searchParams: SearchCentroCostoRequest = useMemo(() => {
    const centroCostoPadreId = searchParamsUrl.get('centroCostoPadreId');
    const numeroCuenta = searchParamsUrl.get('numeroCuenta');
    return {
      denominacion: searchParamsUrl.get('denominacion'),
      numeroCuenta: numeroCuenta ? Number(numeroCuenta) : null,
      centroCostoPadreId: centroCostoPadreId ? Number(centroCostoPadreId) : null,
    };
  }, [searchParamsUrl]);

  const searchCostCentres = useCallback(
    (request: SearchCentroCostoRequest) => {
      const rawData = {
        centroCostoPadreId: request.centroCostoPadreId,
        numeroCuenta: request.numeroCuenta,
        denominacion: request.denominacion,
      };
      // Filtramos valores nulos
      const cleanEntries = Object.entries(rawData)
        .filter(([_, value]) => value !== undefined && value !== null && value !== '')
        .map(([key, value]) => [key, String(value)]);
      setSearchParamsUrl(new URLSearchParams(cleanEntries));
      setReloadToken((v) => v + 1);
    },
    [setSearchParamsUrl],
  );

  const reloadCostCentresAndFilters = useCallback(() => {
    setReloadToken((v) => v + 1);
  }, []);

  return (
    <CostCentresListContext.Provider
      value={{
        searchParams,
        searchCostCentres,
        reloadToken,
        reloadCostCentresAndFilters,
      }}
    >
      {children}
    </CostCentresListContext.Provider>
  );
};
